import {
  FETCHED_PRODUCTS,
  FETCHING_PRODUCT,
  SET_GEORESOURCES,
  SETTING_FT_ELIGIBLE,
  FT_ELIGIBLE_SET
} from './actionTypes';
import { AppActions } from '../../types/store/action';
import { Dispatch } from 'redux';
import CONFIG from '../../config';
import axios from 'axios';
import { IProduct } from '../../types';
import { poll, pollGeoRestrictedResources, pollContants } from '../../utils';

const fetchingProducts = (): AppActions => {
  return {
    type: FETCHING_PRODUCT
  };
};

export const fetchedProducts = (products: IProduct[]): AppActions => {
  return {
    type: FETCHED_PRODUCTS,
    products
  };
};

export const setGeoResources = (settings: any): AppActions => {
  return {
    type: SET_GEORESOURCES,
    currency: settings.currency,
    localeId: settings.localeId,
    countryCode: settings.countryCode
  };
};

export const fetchProducts = (productIds: string[]) => {
  return async function(dispatch: Dispatch) {
    dispatch(fetchingProducts());
    const geoResourcesSettings = await getGeoResourcesSettings();
    dispatch(setGeoResources(geoResourcesSettings));
    const Constants = await pollContants();
    const { SITE_ID } = Constants;

    const productEndpoint = `https://${
      CONFIG.apiHost
    }/s/${SITE_ID}/dw/shop/v20_4/products/(${productIds.join(
      ','
    )})?expand=prices,variations&currency=${geoResourcesSettings.currency.toUpperCase()}&client_id=${
      CONFIG.clientId
    }`;

    if (window.location.host !== 'store.ubi.com') {
      console.log('productEndpoint: ', productEndpoint);
    }

    const response = await axios(productEndpoint);

    if (response.status !== 200) {
      console.log('error: ', response);
    }

    const products: IProduct[] = response.data.data.map((product: any) => {
      const data: IProduct = {
        id: product.id,
        name: product.name,
        regularPrice: parseFloat(JSON.parse(product.c_display_price).regular),
        promoPrice: parseFloat(JSON.parse(product.c_display_price).promo_price),
        discountPercentage: parseFloat(JSON.parse(product.c_display_price).percent_off)
      };

      return data;
    });
    dispatch(fetchedProducts(products));
  };
};

const getGeoResourcesSettings = async () => {
  const objReady = await pollGeoRestrictedResources();

  if (!objReady) {
    return null;
  }
  return {
    currency: (window as any).GeoRestrictedResources.STOREFRONT_CURRENCY_CODE,
    localeId: (window as any).GeoRestrictedResources.STOREFRONT_CURRENT_LOCALE,
    countryCode: (window as any).GeoRestrictedResources.GEORESTRICTED_CURRENTSITE
  };
};

const settingFTEligible = (): AppActions => {
  return {
    type: SETTING_FT_ELIGIBLE
  };
};

const FTEligibleSet = (isEligible: boolean): AppActions => {
  return {
    type: FT_ELIGIBLE_SET,
    isEligible
  };
};

export const setFTEligible = () => {
  return async function(dispatch: Dispatch) {
    dispatch(settingFTEligible());

    const w = window as any;
    const uplayDataAvailable = await poll(
      () => typeof w.uplayData !== 'undefined',
      10000,
      150
    );

    if (!uplayDataAvailable) {
      dispatch(FTEligibleSet(false));
    } else {
      dispatch(FTEligibleSet(w.uplayData['up-plus-ft-eligible'] === 'true'));
    }
  };
};

